"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContext = void 0;
var utils_1 = require("../../utils");
function paramsToObject(searchParams) {
    var e_1, _a;
    var result = {};
    try {
        for (var _b = __values(searchParams.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            result[key] = value;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return result;
}
/**
 * Builds the context part of an event
 */
var createContext = function () {
    var _a, _b;
    var context = {};
    if ((0, utils_1.isServer)()) {
        return context;
    }
    var search = (_a = window.location.search) !== null && _a !== void 0 ? _a : '';
    var hash = (_b = window.location.hash) !== null && _b !== void 0 ? _b : '';
    var term = search.length ? search : hash.replace(/(?=#).*(?=\?)/, '');
    var searchParams = new URLSearchParams(term);
    context.referrer = document.referrer;
    context.queryParams = paramsToObject(searchParams);
    context.userAgent = navigator.userAgent;
    context.locales = navigator.languages.slice();
    return context;
};
exports.createContext = createContext;
//# sourceMappingURL=create-context.js.map